import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";

// import "./external_js/bundle.v.5ce6f06ac.min";
// import "./external_js/technology.v.5ce6f06ac";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
        <Routes />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
